<template>
  <div class="text-center">
    <div style="display: inline-block">
      <btn-layout :item="item" />
    </div>
  </div>
</template>

<script>
import BtnLayout from './BtnLayout'
export default {
  name: 'BtnAutoAdjustment',
  components: { BtnLayout },
  props: {
    item: {
      type: Object,
      required: true
    }
  }
}
</script>
